import { cn } from "@repo/ui/lib/utils";
import Image from "next/image";

// Logo mark for the nav chrome (desktop header pill + mobile ticker) — image
// only, no wordmark. Size it via className height; width follows (square).
// The brand mark as SVG (design/pwa-assets/shemshop, 2026-10-17); SVGs aren't
// run through the image optimizer.
export function BrandLogo({ className }: { className?: string }) {
  return (
    <Image
      src="/assets/logo-mark.svg"
      alt="شمشاپ"
      width={40}
      height={40}
      unoptimized
      priority
      className={cn("h-10 w-auto shrink-0", className)}
    />
  );
}
